import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import styled, { css } from 'styled-components';
import _ from 'lodash';
import { color } from '../../templates/Ui';
import Checkmark from '../../atoms/icons/Checkmark';
import { useTranslation } from 'react-i18next';
const StyledInputWrapper = styled.div `
    position: relative;
    margin-right: 10px;
    margin-bottom: 10px;

    &:last-child {
        margin-right: 0;
    }
`;
const StyledInput = styled.input `
    position: absolute;
    top: 5px;
    left: 3px;
    margin: 0;
    padding: 0;
    height: 1px;
    width: 1px;
    z-index: 0;

    &:focus + label {
        background-color: ${color.gray.light};
    }

    &:checked + label {
        background-color: ${color.gray.light};
        border-color: transparent;

        .filter-text {
            color: ${color.base.base};
        }

        .filter-checkmark {
            opacity: 1;
        }
    }
    &:indeterminate + label {
        color: ${props => props.theme.primary.base};
        font-weight: 600;

        &::before {
            border-color: ${props => props.theme.secondary};
            background-color: ${props => props.theme.secondary};
        }
        &::after {
            background-image: url("data:image/svg+xml, %3Csvg width='15' height='12' viewBox='0 0 15 12' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 4.4C1 4.17909 1.17909 4 1.4 4H13.6C13.8209 4 14 4.17909 14 4.4V6.6C14 6.82091 13.8209 7 13.6 7H1.4C1.17909 7 1 6.82091 1 6.6V4.4Z' fill='white'/%3E%3C/svg%3E");
            opacity: 1;
        }
    }
`;
const StyledLabel = styled.label `
    position: relative;
    display: flex;
    align-items: center;
    transition: all 0.2s ease-in-out;
    border: 1px solid ${color.border.base};
    padding: 6px 10px 9px 38px;
    cursor: pointer;
    font-size: 14px;
    border-radius: 4px;
    background-color: white;
    overflow: hidden;
    z-index: 1;

    &:hover {
        background-color: ${color.gray.light};
    }
`;
const StyledPipe = styled.span `
    transition: width 0.1s ease-in-out;
    position: absolute;
    display: block;
    content: '';
    width: 4px;
    height: 100%;
    left: 0;
    top: 0;

    ${props => props.type === 'Betalingen' &&
    css `
            background-color: ${color.type.payment};
        `};

    ${props => props.type === 'Exploten' &&
    css `
            background-color: ${color.type.summons};
        `};

    ${props => props.type === 'Post' &&
    css `
            background-color: ${color.type.post};
        `};

    ${props => props.type === 'Aantekeningen' &&
    css `
            background-color: ${color.type.annotations};
        `};

    ${props => props.type === 'Processtappen' &&
    css `
            background-color: ${color.type.processSteps};
        `};

    ${props => props.type === 'Brieven' &&
    css `
            background-color: ${color.type.letters};
        `};
`;
const StyledText = styled.span `
    color: ${color.paragraph.base};
`;
const StyledCheckbox = styled.span `
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 3px;
    background-color: white;
    border: 1px solid ${color.border.base};
    width: 20px;
    height: 20px;
    left: 12px;
    top: 7px;
`;
const StyledCheckmark = styled(Checkmark) `
    transition: opacity 0.2s ease-in-out;
    opacity: 0;
    fill: ${color.gray.darkest};
`;
const FilterCheckbox = ({ label, className, type, id, ...props }) => {
    const { t } = useTranslation();
    const [fid] = useState(() => id || _.uniqueId('field-'));
    return (_jsx(_Fragment, { children: _jsxs(StyledInputWrapper, { className: className, children: [_jsx(StyledInput, { type: "checkbox", id: fid, ...props }), _jsxs(StyledLabel, { htmlFor: fid, children: [_jsx(StyledPipe, { className: "filter-pipe", type: type }), _jsx(StyledText, { className: "filter-text", children: t(label) }), _jsx(StyledCheckbox, { children: _jsx(StyledCheckmark, { className: "filter-checkmark" }) })] })] }) }));
};
export default FilterCheckbox;
